import { render, staticRenderFns } from "./SupplementReviewList.vue?vue&type=template&id=9700e96e&scoped=true&"
import script from "./SupplementReviewList.vue?vue&type=script&lang=js&"
export * from "./SupplementReviewList.vue?vue&type=script&lang=js&"
import style0 from "./SupplementReviewList.vue?vue&type=style&index=0&id=9700e96e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9700e96e",
  null
  
)

export default component.exports